var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSystem = function SvgSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M12.1 8.2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "m21.1 8 1.4-2.3-3.9-3.9-2.3 1.4c-.3-.1-.5-.2-.8-.3L14.8.3H9.2l-.7 2.6c-.3.1-.5.2-.8.3L5.4 1.8 1.5 5.7 3 8c-.1.3-.2.5-.3.8l-2.6.7V15l2.6.7c.1.3.2.5.3.8l-1.4 2.3 3.9 3.9 2.3-1.4c.3.1.5.2.8.3l.7 2.6h5.6l.7-2.6c.3-.1.5-.2.8-.3l2.3 1.4 3.9-3.9-1.4-2.3c.1-.3.2-.5.3-.8l2.6-.7V9.4l-2.6-.7c-.1-.2-.2-.5-.4-.7m1 5.4-2.2.5-.2.5-.6 1.5-.3.5 1.2 1.9-1.7 1.7-1.9-1.2-.5.3c-.5.2-1 .5-1.5.6l-.5.2-.5 2.2H11l-.5-2.2-.5-.2-1.5-.6-.5-.3L6.1 20l-1.7-1.7 1.2-1.9L5 16c-.2-.5-.5-1-.6-1.5l-.2-.5-2.2-.5V11l2.2-.5.2-.5.6-1.5.3-.5-1.2-1.9 1.7-1.7 1.9 1.2.5-.3q.75-.45 1.5-.6l.5-.2.5-2.2h2.4l.5 2.2.5.2 1.5.6.5.3L18 4.4 20 6l-1.2 1.9.3.5c.2.5.5 1 .6 1.5l.2.5 2.2.5z"
  })));
};
export default SvgSystem;